import * as actions from '../../store/actions'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import logo from '../../assets/images/eSprawozdania_StartPage.svg'
import StartFooter from './StartFooter'
import LicencjaHeader from './LicencjaHeader'
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline'
import Button from '@material-ui/core/Button'
import Login from './Login'
import Account from './Account'
import { filmURL } from '../../lib/consts'
import styled from 'styled-components'

const StartWithLoginStyle = styled.div`
  .header {
    display: flex;
    justify-content: space-between;
    padding: 12px 24px;
  }

  main {
    h2 {
      margin-top: 24px;
    }

    h2.loginHeader {
      margin-top: 158px;
    }

    h1 {
      margin: 0;
    }

    .buttonStart {
      margin-top: 32px;
      min-width: 120px;
    }

    .buttonLogin {
      margin-top: 8px;
      min-width: 120px;
    }

    .loginText {
      margin-top: 24px;
      text-align: center;
    }

    .regulaminLogowanieText {
      margin-top: 200px;
    }

    .accountContent {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .regulaminLink {
    color: ${props => props.theme.primary500};
  }

  .regulaminZakladanieKontaText {
    margin-top: 0;
    text-align: center;
  }

  .regulaminLoginText {
    margin-top: 130px;
    text-align: center;
  }
`

export class StartWithLogin extends Component {
  state = {
    login: this.props.path === 'login',
    account: this.props.path === 'account',
  }

  render() {
    const { onLogin, onCreateAccount, error, onClearError } = this.props
    return (
      <StartWithLoginStyle>
        {this.state.login && (
          <Login
            onLogin={onLogin}
            onCancel={() => this.setState({ login: false })}
            error={error}
            onCloseError={onClearError}
          />
        )}
        {this.state.account && (
          <Account
            onCreateAccount={onCreateAccount}
            onCancel={() => this.setState({ account: false })}
            error={error}
            onCloseError={onClearError}
          />
        )}
        {!this.state.login && !this.state.account && (
          <>
            <section>
              <header>
                <LicencjaHeader />
              </header>
              <main>
                <img src={logo} alt="logo" />
                <h2>Witamy w programie</h2>
                <h1>e-Sprawozdania Finansowe</h1>
                <Button
                  className="buttonStart"
                  variant="contained"
                  color="primary"
                  onMouseUp={() => this.setState({ login: true })}
                >
                  ZALOGUJ
                </Button>
                <div className="loginText">
                  <p className="disabled-subtitle-1">
                    Nie masz konta?
                    <span
                      className="link disabled-subtitle-1"
                      onClick={() => this.setState({ account: true })}
                    >
                      {' '}
                      Załóż je{' '}
                    </span>
                    i testuj program, bez jakichkolwiek opłat i zobowiązań.
                  </p>
                  <p className="disabled-subtitle-1">
                    O zakupie licencji pozwalającej na utrwalenie efektów Twojej
                    pracy
                    <br />w formie pliku XML z e-Sprawozdaniem możesz
                    zadecydować później.
                  </p>
                </div>
              </main>
              <div className="watch">
                <p className="medium-emphasis-body-1">Zobacz film</p>
                <a href={filmURL} target="_blank" rel="noopener noreferrer">
                  <PlayCircleOutlineIcon className="icon" color="primary" />
                </a>
              </div>
            </section>
            <footer>
              <StartFooter />
            </footer>
          </>
        )}
      </StartWithLoginStyle>
    )
  }
}

const mapStateToProps = state => {
  return {
    error: state.sprawozdanie.err,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onLogin: (email, password) => dispatch(actions.login(email, password)),
    onCreateAccount: (email, password) =>
      dispatch(actions.createAccount(email, password)),
    onClearError: () => dispatch(actions.clearError()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StartWithLogin)
